module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei8.svg";